<template>
  <EditContent property="privacyPolicy" />
</template>
<script setup lang="ts">
import EditContent from "./EditContent.vue";
</script>
